module.exports = __webpack_public_path__ + "1a93eee72a08d2d1e5327b64c6b80fd9.svg";